import './styles/background-curve.scss';

const BackgroundCurveSVG = () => (
  <svg
    className="background-curve"
    preserveAspectRatio="none"
    viewBox="0 0 1440 1400"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path
        d="M1440,0 L1440,1200 C1313.33333,1333.33333 1073.33333,1400 720,1400 C366.666667,1400 126.666667,1333.33333 0,1200 L0,0 C158.562166,140 398.562166,210 720,210 C1041.43783,210 1281.43783,140 1440,0 Z"
        id="path-1"
      ></path>
    </defs>
    <g
      id="Homepage"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g transform="translate(0.000000, -723.000000)" id="Product">
        <g transform="translate(0.000000, 723.000000)">
          <g id="Expanded">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1"></use>
            </mask>
            <use id="Mask" fill="#ECF9E8" xlinkHref="#path-1"></use>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default BackgroundCurveSVG;
